<p>Base nav-item. Specify type by using proper nav item constructor!</p>
